<!--
 * @Description: 
 * @Author: dezhi
 * @Date: 2020-12-17 13:33:34
 * @LastEditTime: 2020-12-17 13:42:44
 * @LastEditors: dezhi
-->
<template>
  <div class="flex sharing-v">
    <Header />
    <div class="info-item">
      <h1 class="text-center">能力水平考试论文提交</h1>
      <div class="info-area wrapper">
        <div class="text-center">
          <img src="@/assets/images/success.png" alt="" />
          <h4>提交成功</h4>
          <p>请耐心等待考试结果</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header";
export default {
  name: "Login",
  components: {
    Header,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.next-box {
  margin-top: 30px;
  justify-content: center;
}
.info-item {
  margin-top: 30px;
}
.info-item h3 {
  margin-bottom: 0;
  font-size: 20px;
  font-weight: bold;
}
.info-area {
  width: 600px;
  margin: 50px auto;
  padding: 40px;
  background: #f9f9f9;
}
h4 {
  margin: 40px 0 20px;
  font-size: 18px;
  font-weight: bold;
}
h4 + p {
  color: #999;
}
</style>